export default
    {
        path: '/jumpPrompt',
        mapPath: '/jumpPrompt',
        component: require('./index').default,
        props: true,
        parent: 'root',
        meta: {
            title:'跳转提示'
        },
        name:'jumpPromptPage'
    }
